/**
 * Generic Facebook Event
 *
 * Most pixel events use similar parameters, so we can declare them once and
 * then pick from them.
 *
 * https://developers.facebook.com/docs/facebook-pixel/reference
 */

/**
 * Either product or product_group based on the content_ids or contents being passed. If the
 * IDs being passed in content_ids or contents parameter are IDs of products then the value
 * should be product. If product group IDs are being passed, then the value should be
 * product_group.
 */
export let ContentType = /*#__PURE__*/function (ContentType) {
  ContentType["DESTINATION"] = "destination";
  ContentType["FLIGHT"] = "flight";
  ContentType["HOTEL"] = "hotel";
  ContentType["PRODUCT"] = "product";
  ContentType["PRODUCT_GROUP"] = "product_group";
  ContentType["APARTMENT"] = "apartment";
  return ContentType;
}({});

/**
 * Content (product)
 */